import React, { useEffect } from "react"
import Layout from "../components/Layout"
import Seo from "../components/Seo"
import "../css/about.css"
import arrowIcon from "../assets/images/about/arrow_icon.svg"
import imgAvatar from "../assets/images/about/img_avatar.png"
import elementDifferent from "../assets/images/about/element_different.png"
import videoActual from "../assets/videos/Ever-green.mp4"
import "aos/dist/aos.css"
import AOS from "aos"
import { graphql } from "gatsby"
import ReactMarkdown from "react-markdown"
import Team from "../components/Team"

const About = ({ data }) => {
  const {
    strapiAbout: { main_heading, about_info, ceo_message, core_values },
  } = data

  useEffect(() => {
    AOS.init({
      disable: false,
      startEvent: "DOMContentLoaded",
      initClassName: "aos-init",
      animatedClassName: "aos-animate",
      useClassNames: false,
      disableMutationObserver: false,
      debounceDelay: 100,
      throttleDelay: 99,
      offset: 120,
      delay: 0,
      duration: 1200,
      easing: "ease",
      once: false,
      mirror: false,
      anchorPlacement: "top-bottom",
    })
  }, [])

  return (
    <Layout>
      <Seo Sitetitle="About Us" />
      <>
        {/* MAIN SECTION */}
        <section className="main-section overflowHidden hero-section-outer">
          <div className="hero-section-about">
            <h2 className="hero-heading-a" data-aos="fade-left">
              {main_heading}
            </h2>
            <a href="/#">
              <img
                src={arrowIcon}
                className="img-fluid mt-4 arrow-down"
                alt="down arrow"
              />
            </a>
          </div>
        </section>
        {/* 2nd-main-section */}
        <section className="2nd-main-section overflowHidden pt-4 mt-5">
          <div className="container">
            <div className="row ">
              <div
                className="col-md-4 col-3 mt-md-0 mt-2 text-center"
                data-aos="fade-right"
              >
                <div className="border-line" />
                <div className="content-inner" />
              </div>
              <div className="col-md-8 col-9" data-aos="fade-down">
                <ReactMarkdown className="about-content">
                  {about_info}
                </ReactMarkdown>
              </div>
            </div>
          </div>
        </section>
        {/*TEAM SECTION*/}
        <section
          id="team"
          claas="team-section  pt-4"
          style={{ overflow: "hidden" }}
        >
          <div className="svg-bg">
            <div className="container-fluid mt-5 ">
              <div className="row ">
                <div className="col-3" data-aos="fade-left">
                  <div className="d-flex justify-content-between">
                    <div>
                      <p className="side-text-stroke">TEAM</p>
                    </div>
                  </div>
                </div>
                <div className="col-4 pl-4" data-aos="fade-up">
                  <div className="d-flex  justify-content-lg-start mt-lg-4 pt-lg-4">
                    <p className="main-section-bluetext-bold my-5 pt-sm-5 pt-3">
                      Who is Us
                    </p>
                  </div>
                </div>
              </div>
              <div className="container">
                <div
                  className="row justify-content-start justify-content-lg-center my-md-5 mb-3 minus-margin-top"
                  data-aos="fade-up"
                >
                  <Team />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Core-Values-Section */}
        <section className="core-values overflowHidden pt-4 main-section hero-section-outer-core-svg position-relative">
          <div className="container-fluid mt-5 ">
            <div className="row">
              <div className="col-9" data-aos="fade-up">
                <div className>
                  <div>
                    <p className="core-stroke">
                      CORE <br className="d-block d-md-none" />{" "}
                      <span className="ml-5 ml-md-3 pl-4 pl-md-3 core-stroke">
                        VALUES
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container pt-5">
            {core_values.map((item, index) => {
              return (
                <div className="row my-5" key={index}>
                  <div className="col-4 text-center" data-aos="fade-left">
                    <div className="border-line" />
                    <div className="content-inner" />
                  </div>
                  <div className="col-8" data-aos="fade-up">
                    <p className="core-section-bluehead">{item.heading}</p>
                    <p className="core-section-text">{item.description}</p>
                  </div>
                </div>
              )
            })}
          </div>
        </section>
        {/* who are we */}
        <section className="who-are-we pt-4 overflowHidden position-relative">
          <img
            src={elementDifferent}
            className="img-fluid who-are-we-img d-sm-none"
            alt="different"
          />
          <div className="container-fluid mt-lg-5 ">
            <div className="row ">
              <div className="col-8" data-aos="fade-up">
                <div className="who-we-are">
                  <div>
                    <p className="core-stroke d-none d-lg-block">WHO ARE WE</p>
                    <p className="core-stroke d-block d-lg-none mobile-txt">
                      WHO WE <br className="mt-2" /> ARE{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="col-4"
                data-aos="fade-donw"
                style={{ overflow: "hidden" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ transform: "rotate(120deg)" }}
                  className="h-75 w-100 d-block d-md-none"
                  viewBox="0 0 770.897 565.283"
                >
                  <g
                    id="element_3"
                    data-name="element 3"
                    transform="translate(-1521 -1137.717)"
                  >
                    <path
                      id="Path_217"
                      data-name="Path 217"
                      d="M1971.344,1138.292l-444.051,129.422,763.143,285.621Z"
                      fill="none"
                      stroke="#cfcfcf"
                      strokeWidth={1}
                    />
                    <path
                      id="Path_218"
                      data-name="Path 218"
                      d="M1716.963,1265.483l104.877,428.431,359.258-379.34Z"
                      fill="none"
                      stroke="#cfcfcf"
                      strokeWidth={1}
                    />
                    <circle
                      id="Ellipse_27"
                      data-name="Ellipse 27"
                      cx={8}
                      cy={8}
                      r={8}
                      transform="translate(1521 1260)"
                      fill="#cfcfcf"
                    />
                    <circle
                      id="Ellipse_29"
                      data-name="Ellipse 29"
                      cx={8}
                      cy={8}
                      r={8}
                      transform="translate(1814 1687)"
                      fill="#cfcfcf"
                    />
                    <circle
                      id="Ellipse_28"
                      data-name="Ellipse 28"
                      cx={16}
                      cy={16}
                      r={16}
                      transform="translate(1699 1249)"
                      fill="#cfcfcf"
                    />
                  </g>
                </svg>
              </div>
            </div>
            <div className="row minus-topmargin">
              <div
                className="col-12 col-md-2 text-center d-none wactch-button d-md-block"
                data-aos="fade-right"
              >
                <p className="who-we-are-text">WATCH</p>
                <p className="who-we-are-text">THE</p>
                <p className="who-we-are-text">VIDEO</p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="103.621"
                  height="71.242"
                  viewBox="0 0 103.621 71.242"
                >
                  <path
                    id="arrow_whoweare"
                    d="M9751,1040v32h68v16l32-32-32-32v16Z"
                    transform="translate(-9749.5 -1020.379)"
                    fill="none"
                    stroke="#009dff"
                    strokeWidth={3}
                  />
                </svg>
              </div>
              <div
                className="col-12 col-md-10 video-wraper pr-0"
                data-aos="fade-left"
              >
                <div className="video-outer">
                  <video width="100%" autoPlay muted loop>
                    <source src={videoActual} type="video/mp4" />
                  </video>
                </div>
              </div>
            </div>
            <div className="who-are-we-svgbg" />
            <div>
              <div
                className=" text-center d-flex d-md-none justify-content-end mt-5"
                data-aos="fade-down"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ transform: "rotate(-90deg)" }}
                  width="103.621"
                  height="71.242"
                  viewBox="0 0 103.621 71.242"
                >
                  <path
                    id="arrow_whoweare"
                    d="M9751,1040v32h68v16l32-32-32-32v16Z"
                    transform="translate(-9749.5 -1020.379)"
                    fill="none"
                    stroke="#009dff"
                    strokeWidth={3}
                  />
                </svg>
                <div className="wacth-video-btn" data-aos="fade-up">
                  <p className="who-we-are-text">WATCH</p>
                  <p className="who-we-are-text">THE</p>
                  <p className="who-we-are-text">VIDEO</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* messagefromCEO */}
        <section className="message-from-ceo overflowHidden">
          <div
            className="container-fluid mt-5 "
            style={{ overflow: "hidden !important" }}
          >
            <div className="row ">
              <div className="col-12 col-md-8 mt-5 mt-md-0 padding-left-mob">
                <div
                  className="d-flex justify-content-center justify-content-md-between"
                  data-aos="fade-right"
                >
                  <div className="mt-5 w-100">
                    <p className="core-stroke message-txt message  mt-lg-5 pt-lg-5">
                      MESSAGE
                    </p>
                    <p className="core-stroke message-txt from-ceo ml-5 ml-lg-0">
                      FROM CEO
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="col-md-4 d-none d-lg-block"
                data-aos="fade-down"
                style={{ overflow: "hidden !important" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="mt-5 h-75 w-75 core-minus-margin"
                  style={{ transform: "rotate(-180deg)" }}
                  viewBox="0 0 436.994 795.173"
                >
                  <g
                    id="element_2"
                    data-name="element 2"
                    transform="translate(99.994 -451.827)"
                  >
                    <path
                      id="Path_148"
                      data-name="Path 148"
                      d="M-36.889,453.239,201.873,803.571-99.369,1060.185Z"
                      fill="none"
                      stroke="#cfcfcf"
                      strokeWidth={1}
                    />
                    <path
                      id="Path_149"
                      data-name="Path 149"
                      d="M49.236,773.1l279.828,258.075L132.67,1240.249Z"
                      fill="none"
                      stroke="#cfcfcf"
                      strokeWidth={1}
                    />
                    <circle
                      id="Ellipse_23"
                      data-name="Ellipse 23"
                      cx={16}
                      cy={16}
                      r={16}
                      transform="translate(186 787)"
                      fill="#cfcfcf"
                    />
                    <circle
                      id="Ellipse_24"
                      data-name="Ellipse 24"
                      cx={8}
                      cy={8}
                      r={8}
                      transform="translate(321 1024)"
                      fill="#cfcfcf"
                    />
                    <circle
                      id="Ellipse_25"
                      data-name="Ellipse 25"
                      cx={8}
                      cy={8}
                      r={8}
                      transform="translate(125 1231)"
                      fill="#cfcfcf"
                    />
                    <circle
                      id="Ellipse_26"
                      data-name="Ellipse 26"
                      cx={8}
                      cy={8}
                      r={8}
                      transform="translate(43 767)"
                      fill="#cfcfcf"
                    />
                  </g>
                </svg>
              </div>
            </div>
            <div className="row minus-margin">
              <div className="col-12 pt-5" data-aos="fade-up">
                <p className="message-from-ceo-text text-sm-center">
                  {" "}
                  <span className="letter">Letter</span>{" "}
                  <span className="commitment">of Commitment</span>
                </p>
              </div>
            </div>
            <div className="container my-5">
              <div data-aos="fade-right">
                <div className="row">
                  <div className="col-lg-4 col-xs-12 my-3">
                    <img
                      src={imgAvatar}
                      className="w-lg-100 h-lg-100 img-fluid"
                      alt="avatar"
                    />
                  </div>
                  <div className="col-lg-8 col-xs-12 mt-lg-3">
                    <p className="core-section-text">{ceo_message}</p>
                    <p className="core-section-text">
                      Thank you for working with Undorm,
                    </p>
                    <p className="core-section-text">CEO</p>
                    <p className="core-section-text">Erick Rodriguez,</p>
                    <p className="core-section-text">(702) 339-1414</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    </Layout>
  )
}

export const query = graphql`
  {
    strapiAbout {
      main_heading
      about_info
      ceo_message
      core_values {
        heading
        description
      }
    }
  }
`

export default About
